import StorageService from '@js/modules/storage';


const HelperMapModule = {
    _helperModel: {
        $mapHelperContainer: undefined,
        $mapHelperMessage: undefined,

        maximumHelperCount: 3,
        hideHelperAfter: 6000
    },

    plugHelperEvents() {
        this._helperModel.$mapHelperContainer = this._model.$mapId.querySelector('#map-helper-container');
        this._helperModel.$mapHelperMessage = this._model.$mapId.querySelector('#map-helper-message');
    },

    displayMapHelper(helperMessage, options = {}) {
        if (options.limitDisplay && this._isHelperLimitReached(true)) {
            return;
        }

        if (helperMessage) {
            this._helperModel.$mapHelperContainer.style.display = 'block';
            this._helperModel.$mapHelperMessage.innerText = helperMessage;

            setTimeout(() => this.hideHelpers(), this._helperModel.hideHelperAfter);
        } else {
            this.hideHelpers();
        }
    },

    hideHelpers() {
        this._helperModel.$mapHelperContainer.style.display = 'none';
    },

    /* Private Methods
    ******************** */
    _isHelperLimitReached(increment) {
        let helperInfoCount = StorageService.getItem('MapHelperInfoCount');

        if (increment) {
            if (helperInfoCount >= 0) {
                helperInfoCount += 1;
            } else {
                helperInfoCount = 0;
            }

            StorageService.setItem('MapHelperInfoCount', helperInfoCount);
        }

        return helperInfoCount > this._helperModel.maximumHelperCount;
    }
};

export default HelperMapModule;
